/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusDownLeftIcon16Solid = forwardRef('ArrowShapeDRadiusDownLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 14.017c0 .847-1.023 1.27-1.622.672L.574 8.884a1.25 1.25 0 0 1 0-1.768l5.804-5.805C6.977.713 8 1.137 8 1.983v2.758c1.41-.033 2.28-.176 2.996-.504.83-.381 1.543-1.051 2.643-2.368a.75.75 0 0 1 1.324.428c.225 3.159-.585 5.435-2.095 6.916-1.313 1.289-3.066 1.885-4.868 2.01v2.794Z" })));
});
